import axios from "axios";
import config from "../../config";

const baseUrl = config.baseUrl;
const BASE = "/api/rit";

const authHeaders = (token) => ({
  headers: { Authorization: `Bearer ${token}` },
  withCredentials: true,
});

export const getAutorizados = async (params, token) => {
  const response = await axios.get(`${baseUrl}${BASE}/autorizados`, {
    ...authHeaders(token),
    params,
  });
  return response.data;
};

// Solo municipios con cupos > 0 (los únicos que pueden tener entregas).
export const getMunicipiosAutorizados = async (token) => {
  const response = await axios.get(`${baseUrl}${BASE}/autorizados/municipios`, authHeaders(token));
  return response.data.data;
};

// alcance: undefined (solo Autorizados, comportamiento original) | "todas"
// (rol Supervisor DPS — el backend valida el rol).
export const getSoportesLote = async (idEncuesta, identificaciones, token, alcance) => {
  const response = await axios.post(
    `${baseUrl}${BASE}/autorizados/soportes`,
    { idEncuesta, identificaciones, ...(alcance && { alcance }) },
    authHeaders(token)
  );
  return response.data.data;
};

// accion: "marcar" | "desmarcar" — protegido en backend, solo administradores.
export const actualizarRevision = async (idEncuesta, identificacion, accion, token) => {
  const response = await axios.put(
    `${baseUrl}${BASE}/autorizados/revision`,
    { idEncuesta, identificacion, accion },
    authHeaders(token)
  );
  return response.data;
};

export const getHistorialRevision = async (idEncuesta, identificacion, token) => {
  const response = await axios.get(`${baseUrl}${BASE}/autorizados/revision/historial`, {
    ...authHeaders(token),
    params: { idEncuesta, identificacion },
  });
  return response.data.historial;
};

// Dispara en el backend la verificación de las 3 entregas (573/667/690), una
// por una, en segundo plano (no espera a que termine) — protegido, solo
// administradores. Así, sin importar a qué pestaña se cambie, apenas le
// toque su turno queda tibia. Consultar progreso con getEstadoPrecalentado.
export const precalentarTodasSoportes = async (token) => {
  const response = await axios.post(`${baseUrl}${BASE}/autorizados/soportes/precalentar-todas`, {}, authHeaders(token));
  return response.data;
};

export const getEstadoPrecalentado = async (idEncuesta, token) => {
  const response = await axios.get(`${baseUrl}${BASE}/autorizados/soportes/precalentar/estado`, {
    ...authHeaders(token),
    params: { idEncuesta },
  });
  return response.data;
};
